export default function Responsabilidades() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-bold text-foreground-900">Responsabilidades e Restrições</h1>
        <p className="text-sm text-foreground-500 mt-1">Gestão de direitos, deveres e restrições legais</p>
      </div>
      <div className="bg-white rounded-xl border border-background-200/70 p-12 text-center">
        <div className="w-16 h-16 rounded-2xl bg-warning-50 flex items-center justify-center mx-auto mb-4">
          <i className="ri-shield-check-line text-warning-500 text-2xl"></i>
        </div>
        <h3 className="text-lg font-semibold text-foreground-900 mb-2">Fase 5: Responsabilidades e Restrições</h3>
        <p className="text-sm text-foreground-500 max-w-md mx-auto">
          Registro de responsabilidades administrativas, restrições ambientais (APP, tombamento) conforme LADM-FloraIQ.
        </p>
      </div>
    </div>
  );
}